<template>
  <div class="main_dialog">
    <div class="main_dialog_frame">
      <div
        class="close_edit_panel_btn"
        @click="dialog_close"
        v-if="$store.state.app.main_dialog_close_IsShow"
      >
        <i class="close_edit_panel_icon el-icon-close"></i>
      </div>
      <div class="main_dialog_content">
        <component :is="getModuleName"></component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "main_dialog",
  props: {},
  methods: {
    dialog_close() {
      this.templet.dialog_close();
      this.templet.row_Mongolia_close();
      // !== -1 为在线表单项关闭弹窗
      if (this.$store.state.app.se_item_index !== -1 || this.$store.state.app.form_item_is_button == true) {
        this.$store.commit("row/SET_edit_mongolia", false);
        this.$store.commit("row/SET_edit_mongolia_horizontal", false);
        this.$store.commit("app/set_se_item_index", -1);
      }
    }
  },
  computed: {
    getModuleName() {
      const edit_name = this.$store.state.main_dialog.edit_name;
      if (edit_name) {
        const edit_module_name = edit_name + "_edit";
        return edit_module_name;
      } else {
        return "";
      }
    }
  },
  components: {
    layout_row_edit(resolve) {
      require(["@/widgets/layout_row/edit"], resolve);
    },
    layout_column_edit(resolve) {
      require(["@/widgets/layout_column/edit"], resolve);
    },
    layout_column_new_edit(resolve) {
      require(["@/widgets/layout_column_new/edit"], resolve);
    },
    basic_webtitle_edit(resolve) {
      require(["@/widgets/basic_webtitle/edit"], resolve);
    },
    full_screen_banner_edit(resolve) {
      require(["@/widgets/full_screen_banner/edit"], resolve);
    },
    basic_navbar_edit(resolve) {
      require(["@/widgets/basic_navbar/edit"], resolve);
    },
    basic_text_edit(resolve) {
      require(["@/widgets/basic_text/edit"], resolve);
    },
    basic_text_rich_type_edit(resolve) {
      require(["@/widgets/basic_text_rich_type/edit"], resolve);
    },
    basic_button_edit(resolve) {
      require(["@/widgets/basic_button/edit"], resolve);
    },
    basic_picture_edit(resolve) {
      require(["@/widgets/basic_picture/edit"], resolve);
    },
    basic_searchs_edit(resolve) {
      require(["@/widgets/basic_searchs/edit"], resolve);
    },
    basic_searchs_results_edit(resolve) {
      require(["@/widgets/basic_searchs_results/edit"], resolve);
    },
    basic_map_edit(resolve) {
      require(["@/widgets/basic_map/edit"], resolve);
    },
    submit_form_edit(resolve) {
      require(["@/components/set_link/components/submit_form/edit"], resolve);
    },
    basic_banner_edit(resolve) {
      require(["@/widgets/basic_banner/edit"], resolve);
    },
    basic_download_edit(resolve) {
      require(["@/widgets/basic_download/edit"], resolve);
    },
    basic_video_edit(resolve) {
      require(["@/widgets/basic_video/edit"], resolve);
    },
    basic_list_photos_edit(resolve) {
      require(["@/widgets/basic_list_photos/edit"], resolve);
    },
    basic_article_list_edit(resolve) {
      require(["@/widgets/basic_article_list/edit"], resolve);
    },
    basic_article_info_edit(resolve) {
      require(["@/widgets/basic_article_info/edit"], resolve);
    },
    basic_rich_text_edit(resolve) {
      require(["@/widgets/basic_rich_text/edit"], resolve);
    },
    basic_nleavemessage_edit(resolve) {
      require(["@/widgets/basic_nleavemessage/edit"], resolve);
    },
    basic_form_edit(resolve) {
      require(["@/widgets/basic_nleavemessage/components/basic_form"], resolve);
    },
    basic_atlas_catalog_edit(resolve) {
      require(["@/widgets/basic_atlas_catalog/edit"], resolve);
    },
    basic_product_classification_edit(resolve) {
      require(["@/widgets/basic_product_classification/edit"], resolve);
    },
    basic_article_classification_edit(resolve) {
      require(["@/widgets/basic_article_classification/edit"], resolve);
    },
    basic_embed_page_edit(resolve) {
      require(["@/widgets/basic_embed_page/edit"], resolve);
    },
    basic_plugin_code(resolve) {
      require(["@/widgets/basic_plugin_code/edit"], resolve);
    },
    basic_product_display_edit(resolve) {
      require(["@/widgets/basic_product_display/edit"], resolve);
    },
    basic_product_detail_edit(resolve) {
      require(["@/widgets/basic_product_detail/edit"], resolve);
    },
    basic_plugin_code_edit(resolve) {
      require(["@/widgets/basic_plugin_code/edit"], resolve);
    },
    mobile_header_edit(resolve) {
      require(["@/widgets/mobile_header/edit"], resolve);
    },
    basic_h1_edit(resolve) {
      require(["@/widgets/basic_h1/edit"], resolve);
    },
    basic_crumbs_edit(resolve) {
      require(["@/widgets/basic_crumbs/edit"], resolve);
    },
    basic_notice_edit(resolve) {
      require(["@/widgets/basic_notice/edit"], resolve);
    },
    basic_icon_combination_edit(resolve) {
      require(["@/widgets/basic_icon_combination/edit"], resolve);
    },
    basic_language_edit(resolve) {
      require(["@/widgets/basic_language/edit"], resolve);
    },
    basic_footnav_edit(resolve) {
      require(["@/widgets/basic_footnav/edit"], resolve);
    },
    basic_classification_edit(resolve) {
      require(["@/widgets/basic_classification/edit"], resolve);
    },

    basic_magic_number_edit(resolve) { // 动态数字
      require(["@/widgets/basic_magic_number/edit"], resolve);
    },
    basic_progress_edit(resolve) { // 进度条
      require(["@/widgets/basic_progress/edit"], resolve)
    },
    basic_video_display_edit(resolve) {
      require(["@/widgets/basic_video_display/edit"], resolve);
    },
    basic_download_display_edit(resolve) {
      require(["@/widgets/basic_download_display/edit"], resolve);
    },
    basic_job_edit(resolve) {
      require(["@/widgets/basic_job/edit"], resolve);
    },
    basic_picture_text_swiper_edit(resolve) {
      require(["@/widgets/basic_picture_text_swiper/edit"], resolve);
    },
    basic_row_tab_edit(resolve) {
      require(["@/widgets/basic_row_tab/edit"], resolve);
    },
    basic_member_register_edit(resolve) {
      require(["@/widgets/basic_member_register/edit"], resolve);
    },
    basic_member_center_edit(resolve) {
      require(["@/widgets/basic_member_center/edit"], resolve);
    },
    basic_flod_text_edit(resolve) { // 折叠文本
      require(["@/widgets/basic_flod_text/edit"], resolve);
    },
    basic_development_history_edit(resolve) {
      require(["@/widgets/basic_development_history/edit"], resolve);
    },
    basic_video_detail_edit(resolve) { // 视频详情
      require(["@/widgets/basic_video_detail/edit"], resolve);
    },
    basic_zhlanguage_edit(resolve) { // 视频详情
      require(["@/widgets/basic_zhlanguage/edit"], resolve);
    },
    basic_floating_frame_edit(resolve) { // 浮框
      require(["@/widgets/basic_floating_frame/edit"], resolve)
    },
    basic_login_edit(resolve) { // 登录
      require(["@/widgets/basic_login/edit"], resolve)
    },
    basic_retrieve_password_edit(resolve) {
      require(["@/widgets/basic_retrieve_password/edit"], resolve);
    },
    basic_recommend_list_edit(resolve) { // 热门推荐
      require(["@/widgets/basic_recommend_list/edit"], resolve)
    },
    basic_flod_text_list_edit(resolve) { // 折叠文本
      require(["@/widgets/basic_flod_text_list/edit"], resolve);
    }
  },
  mounted() {
    const that = this;
    //左侧框拖拽
    $(".main_dialog").draggable({
      containment: "window",
      //cancel: ".el-slider__button-wrapper"
    });
    $(".main_dialog_frame").mousedown(function () {
      that.templet.main_dialog_blur($(this).find("input"));
      that.templet.main_dialog_blur($(this).find("textarea"));
    });
    //.el-slider__button-wrapper
    $(".main_dialog").on("mouseup", ".el-slider__button-wrapper", function () {
      that.templet.main_dialog_blur($(".main_dialog_frame").find("input"));
      that.templet.main_dialog_blur($(".main_dialog_frame").find("textarea"));
    });

  }
};
</script>

<style scoped lang="scss">
.main_dialog {
  position: fixed;
  top: 100px;
  right: 150px;
  width: 384px;
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  height: calc(100% - 80px);
  max-height: 740px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  z-index: 2000;

  .main_dialog_frame {
    position: relative;
    width: 100%;
    height: 100%;
    /*overflow-y: auto;*/
    .close_edit_panel_btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 58px;
      height: 58px;
      cursor: pointer;
      line-height: 48px;
      font-size: 30px;
      text-align: center;
      z-index: 10;
      color: #fff;

      i {
        font-size: 18px;
      }
    }

    .main_dialog_content {
      height: 100%;

      /deep/ .title {
        color: #303133;
      }

      /deep/ .panel_item_title {
        color: #303133;
      }
    }

    .main_dialog_header {
      font-family: "微软雅黑";
      overflow: hidden;
      width: 100%;
      height: 58px;
      font-size: 0;
      background: #5874d8;
      -webkit-border-radius: 5px 5px 0 0;
      -moz-border-radius: 5px 5px 0 0;
      border-radius: 5px 5px 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/main_dialog/index.vue